"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = waitReject;
function waitReject(duration, reason = 'TIMED_OUT') {
    return new Promise((_, reject) => {
        setTimeout(() => reject(reason), duration);
    });
}
